import { Column } from 'app/design/primitives/box';
import { type useAllTags, type ClosestListingsByTag } from 'app/network/listing';
import { Strategies } from 'app/screens/billboard/all-listings/components/recommended-listings';
import { DesktopRecommendationSection } from 'app/screens/billboard/all-listings/components/recommended-listings.large';

export function LandingInterestRecommendationsBlock({
  onOpenOfferTag,
  recommendations,
  tags,
}: {
  onOpenOfferTag: (tagId: string) => void;
  recommendations: ClosestListingsByTag[];
  tags: Awaited<ReturnType<typeof useAllTags>>['data'];
}) {
  return (
    <Column rowGap="spacing.general.x4">
      {recommendations.map((recommendation) => (
        <DesktopRecommendationSection
          key={recommendation.tagId}
          strategyProps={{ strategy: Strategies.YourInterest }}
          recommendationState={{ recommendations: recommendation.listings, isPending: false, show: true }}
          recommendations={recommendation.listings}
          titleSuffix={tags?.find((tag) => tag.id === recommendation.tagId)?.tagName}
          onViewAll={() => onOpenOfferTag(recommendation.tagId)}
        />
      ))}
    </Column>
  );
}
